import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { linkMessages, contentMessages } from './messages';

const HelpfulLinks: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <ul>
        <li>
          <strong>
            <FormattedMessage {...contentMessages.degreeProgrammesTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.degreeProgrammesDesc}
            values={{
              link: (
                <a
                  href={intl.formatMessage(
                    linkMessages.degreeProgrammesSearchLink,
                  )}
                >
                  <FormattedMessage
                    {...contentMessages.degreeProgrammesLinkText}
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage {...contentMessages.continuingTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.continuingDesc}
            values={{
              link: (
                <a
                  href={intl.formatMessage(
                    linkMessages.continuingEducationSearchLink,
                  )}
                >
                  <FormattedMessage {...contentMessages.continuingLinkText} />
                </a>
              ),
            }}
          />
        </li>

        {intl.locale === 'de' && (
          <li>
            <strong>
              <FormattedMessage {...contentMessages.phContinuingTitle} />
            </strong>
            <br />
            <FormattedMessage
              {...contentMessages.phContinuingDesc}
              values={{
                link: (
                  <a
                    href={intl.formatMessage(
                      linkMessages.phContinuingEducationSearchLink,
                    )}
                  >
                    <FormattedMessage
                      {...contentMessages.phContinuingLinkText}
                    />
                  </a>
                ),
              }}
            />
          </li>
        )}

        <li>
          <strong>
            <FormattedMessage {...contentMessages.infoEventsTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.infoEventsDesc}
            values={{
              degree: (
                <a href={intl.formatMessage(linkMessages.infoEventsDegreeLink)}>
                  <FormattedMessage
                    {...contentMessages.infoEventsDegreeLinkText}
                  />
                </a>
              ),
              cont: (
                <a
                  href={intl.formatMessage(
                    linkMessages.infoEventsContinuingLink,
                  )}
                >
                  <FormattedMessage
                    {...contentMessages.infoEventsContLinkText}
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage {...contentMessages.eventsTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.eventsDesc}
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.eventsSearchLink)}>
                  <FormattedMessage {...contentMessages.eventsLinkText} />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage {...contentMessages.newsTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.newsDesc}
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.newsRoomLink)}>
                  <FormattedMessage {...contentMessages.newsLinkText} />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage {...contentMessages.personsTitle} />
          </strong>
          <br />
          <FormattedMessage
            {...contentMessages.personsDesc}
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.personsSearchLink)}>
                  <FormattedMessage {...contentMessages.personsLinkText} />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage {...contentMessages.otherTitle} />
          </strong>
          <br />
          <FormattedMessage {...contentMessages.otherDesc} />
        </li>
      </ul>
      <p>
        <FormattedMessage
          {...contentMessages.helpDesc}
          values={{
            siteAdmin: (
              <a href={intl.formatMessage(linkMessages.siteAdminLink)}>
                <FormattedMessage {...contentMessages.helpLinkText} />
              </a>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage {...contentMessages.thanks} />
      </p>
    </>
  );
};

export default HelpfulLinks;
